import { forwardRef } from '@heroui/system';
import { MdOutlineCalendarToday } from 'react-icons/md';
import { DatePicker, DatePickerProps } from '@heroui/react';

type CustomDatePickerProps = DatePickerProps & {
  type?: 'default' | 'custom';
};

const CustomDatePicker = forwardRef<'input', CustomDatePickerProps>((props, ref) => {
  const { calendarWidth = 260, value, label, onChange, type = 'default', ...restProps } = props;
  const hasValue = value !== undefined && value !== null;
  const isDefaultType = type === 'default';

  return (
    <DatePicker
      ref={ref}
      selectorIcon={<MdOutlineCalendarToday size={20} />}
      label={label}
      value={value}
      calendarWidth={calendarWidth}
      classNames={{
        base: [
          'tmdx-input',
          'tmdx-calendar',
          isDefaultType ? 'tmdx-input-date group [&>div]:bg-base-60' : 'bg-base-50 [&>div]:bg-base-50',
          '[&>div]:rounded-lg',
          !label ? 'noLabel' : 'hasLabel',
          hasValue ? 'hasValue' : '',
        ],
        selectorButton: 'text-base-5',
        label: [
          'text-base-20',
          'text-s-r!',
          'tmdx-input__label',
          'group-focus-within:text-base-10',
          'group-data-[invalid=true]:text-danger!',
        ],
        input: [isDefaultType ? '' : 'text-m-r!', isDefaultType ? '' : 'text-base-5'],
        segment: ['slashed-zero', isDefaultType ? '' : 'text-m-r!', isDefaultType ? '' : 'text-base-5'],
        popoverContent: 'tmdx-calendar__popover bg-base-60 shadow-xl',
        calendarContent: 'tmdx-calendar__content min-w-65',
        errorMessage: ['whitespace-normal', 'break-words'],
      }}
      onChange={onChange}
      {...restProps}
    />
  );
});

CustomDatePicker.displayName = 'CustomDatePicker';

export default CustomDatePicker;
